<template>
  <div class="print">
    <loader v-show="loading" />
    <div class="table-responsive" style="margin-bottom: 200px">
      <table border="0" style="width: 100%">
        <tbody>
          <tr>
            <td style="width: 60%">
              <img src="/logo/logo_512.png" height="100px;" />
              <br />
            </td>
            <td style="width: 40%; color: #000;">
              <strong style="font-size: 22px">INVOICE PENJUALAN</strong>
              <br />
              Nomor Invoice : {{ data.invoice }}
              <br />
              Tanggal : {{ data.created_at | dateFormat }}
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" style="margin: 10px 0; color: #000;" class="table-header">
        <tbody v-if="data.customer">
          <tr>
            <td colspan="3">Jl. Tegalsari Raya No. 80 Kalangan, Banguntapan, Bantul</td>
          </tr>
          <tr>
            <td colspan="3" style="border-bottom: 2px solid #000;">Tlp. 08113454647 / 08995446891</td>
          </tr>
          <tr>
            <td>Kepada</td>
            <td>:</td>
            <td width="80%">{{ data.customer.name }}</td>
          </tr>
          <tr>
            <td>Alamat</td>
            <td>:</td>
            <td>{{ data.customer.address }}</td>
          </tr>
          <tr>
            <td>Nomor Telepon</td>
            <td>:</td>
            <td>{{ data.customer.phone }}</td>
          </tr>
        </tbody>
      </table>
      <div class="table-print">
        <table border="1" class="bordered" style="width: 100%; table-layout: fixed; ">
          <tbody>
            <tr>
              <td width="40">No</td>
              <td width="110">Kode Barang</td>
              <td width="300">Jenis Barang</td>
              <td width="40">Qty</td>
              <td width="40">CS</td>
              <td width="100">Harga</td>
              <td width="110">Sub Total</td>
            </tr>
            <tr v-for="(d, k) in data.sale_details" :key="k">
              <td class="center">{{ k + 1 }}</td>
              <td>{{ d.item.code }}</td>
              <td v-if="d.item">{{ d.item.name }}</td>
              <td class="center">{{ d.qty_real }}</td>
              <td class="center">
                <span v-if="d.item && d.item.unit && d.item.unit">
                  {{ d.item.unit.unit }}
                </span>
              </td>
              <td class="right" width="100">
                {{ d.price | thousandSeparator }}
              </td>
              <td class="right" width="100">
                {{ d.sub_total | thousandSeparator }}
              </td>
            </tr>
            <tr class="footer">
              <td colspan="6" align="right">
                <b>Total</b>
              </td>
              <td class="right">
                <b>Rp {{ data.total | thousandSeparator }}</b>
              </td>
            </tr>
            <tr class="footer">
              <td colspan="6" align="right">
                <b>Disc. Promo</b>
              </td>
              <td class="right">
                <b>Rp {{ data.discount | thousandSeparator }}</b>
              </td>
            </tr>
            <tr class="footer">
              <td colspan="6" align="right">
                <b>Grand Total</b>
              </td>
              <td class="right">
                <b>Rp {{ data.grand_total | thousandSeparator }}</b>
              </td>
            </tr>
            <tr class="footer">
              <td colspan="7">
                <b>Terbilang: {{ data.terbilang }} Rupiah</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <table class="payment-detail">
        <tbody>
          <tr>
            <td colspan="2">Detail Pembayaran:</td>
            <td>
              Catatan: {{ data.note }}
            </td>
          </tr>
          <tr>
            <td v-for="(bank,k) in banks" :key="k" class="bank-to">
              {{ `${bank.name} - ${bank.number}` }}<br />
              a.n {{ bank.owner }}
            </td>
            <td style="font-weight: 100">
              <p style="width: 100%; text-align: right">Hormat Kami</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Loader from '../../components/Loader.vue'
import { showErrorMessage } from '../../lib/helpers';
import { HTTPAUTH } from "../../lib/httplib";
export default {
  components: {
    Loader,
  },
  data () {
    return {
      data: [],
      includeDeliveryLetter: false,
      number: 0,
      loading: true,
      banks: [
        {
          name: "BCA",
          number: "8465611843",
          owner: "Silvia Ayu Pertiwi"
        },
        {
          name: "Mandiri",
          number: "1560010436956",
          owner: "Silvia Ayu Pertiwi"
        },
      ]
    };
  },
  created () {
    const params = this.$route.params;
    const query = this.$route.query;
    if (query.preview) {
      this.get(params.id, false);
    } else {
      this.get(params.id, true);
    }
  },
  methods: {
    async get (id, print) {
      this.loading = true
      HTTPAUTH.get("/api/v1/sale/" + id).then(async (res) => {
        this.data = res.data.data;
        const detail = this.data.sale_details;
        for (var i in detail) {
          if (detail[i].include_delivery_letter) {
            this.includeDeliveryLetter = true;
            this.includeDeliveryLetterCount++;
          }
        }
        this.loading = false
        if (print) {
          await this.doPrint()
        }
      }).catch(eres => {
        showErrorMessage(eres)
        this.loading = false
      });
    },
    async doPrint () {
      setTimeout(function async () {
        window.print();
        window.close();
      }, 500);
    },
  },
};
</script>
<style>
.footer {
  font-weight: 100;
}
</style>